import React from "react";
import RewardSystemHistoryView from "../components/reward-system-history-view";
import { withApollo } from '@apollo/client/react/hoc';
import { compose } from "modules/core";
import { REWARD_HISTORY } from "../graphql/rewardSubscription.gql";

const RewardSystemHistoryContainer = (props) => {
  const { client, rewardPermission } = props;
  const [historyList, setHistoryList] = React.useState([]);
  const [nextPageCursor, setNextPageCursor] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    if (rewardPermission && rewardPermission.reward_history_permissions)
      getHistoryData();
    else if (rewardPermission && rewardPermission.reward_history_permissions === false)
      setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rewardPermission]);
  const getHistoryData = async (endCursor) => {
    try {
      const { data } = await client.query({
        query: REWARD_HISTORY,
        fetchPolicy: 'network-only',
        variables: { endCursor: endCursor },
      });
      if (data) {
        const allActivities = data?.allRewardPoints?.edges.map(({ node }) => ({ action: node.rule.category.name, points: node.points, date: node.earnedAt })) || [];
        if (data.allRewardPoints?.pageInfo?.hasNextPage) setNextPageCursor(data.allRewardPoints?.pageInfo?.endCursor);
        else setNextPageCursor(null);
        setHistoryList([...historyList, ...allActivities]);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching reward history:", error);
      setLoading(false);
    }
  }
  return (
    <RewardSystemHistoryView historyList={historyList} loading={loading} getHistoryData={getHistoryData} nextPageCursor={nextPageCursor} permission={rewardPermission?.reward_history_permissions} />
  );
}

export default compose(withApollo)(RewardSystemHistoryContainer);